import { type ComponentStyleConfig } from "@chakra-ui/react";
import { Text as ThemeTextStyling } from "./Text";

export const Heading = (): ComponentStyleConfig => ({
	sizes: {
		...ThemeTextStyling().sizes
	},
});